export default "__VITE_ASSET__BX7K0Cge__"